/* Support page: contact form (validation + fetch submit), Quick Q&A accordion. */
(function () {
  var valid = function (v) { return /\S+@\S+\.\S+/.test(v || ''); };
  var SS_KEY = 'dozzee.contact';

  /* ---------- contact ---------- */
  function initContact(root) {
    var form = root.querySelector('[data-contact-form]') || root.querySelector('form');
    if (!form || form._sp) return; form._sp = 1;
    var strings = {};
    try { strings = JSON.parse(root.querySelector('[data-contact-strings]').textContent); } catch (e) {}
    var open = form.querySelector('[data-contact-open]'), sent = form.querySelector('[data-contact-sent]');
    var name = form.querySelector('[data-c-name]'), email = form.querySelector('[data-c-email]'), msg = form.querySelector('[data-c-msg]');
    var err = form.querySelector('[data-c-err]'), btn = form.querySelector('[type="submit"]');

    function showSent(n, em) {
      if (n && strings.thanks) form.querySelector('[data-c-thanks]').textContent = strings.thanks.replace('%%NAME%%', n);
      if (em && strings.reply) form.querySelector('[data-c-reply]').textContent = strings.reply.replace('%%EMAIL%%', em);
      open.hidden = true; sent.hidden = false;
    }

    // Server path (native POST → ?contact_posted=true): fill in name/email remembered before submit.
    if (!sent.hidden) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(SS_KEY) || 'null'); sessionStorage.removeItem(SS_KEY); } catch (e) {}
      if (saved) showSent(saved.n, saved.e);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = name.value.trim(), em = email.value.trim(), m = msg.value.trim();
      if (!n) { err.textContent = strings.name || ''; name.focus(); return; }
      if (!valid(em)) { err.textContent = strings.email || ''; email.focus(); return; }
      if (!m) { err.textContent = strings.msg || ''; msg.focus(); return; }
      err.textContent = '';
      try { sessionStorage.setItem(SS_KEY, JSON.stringify({ n: n, e: em })); } catch (x) {}
      if (btn) btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) {
          // Shopify spam protection: let the real form submit so the challenge page shows.
          if (/\/challenge/.test(r.url)) { form.submit(); return; }
          if (!r.ok) throw new Error(r.status);
          return r.text().then(function (html) {
            // Shopify re-renders this page; when the post failed validation our error line carries form.errors.
            if (!/contact_posted=true/.test(r.url)) {
              try {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var s = doc.querySelector('[data-contact-sent]'), er = doc.querySelector('[data-c-err]');
                if (s && s.hasAttribute('hidden') && er && er.textContent.trim()) { err.textContent = er.textContent.trim(); return; }
              } catch (x) {}
            }
            try { sessionStorage.removeItem(SS_KEY); } catch (x) {}
            showSent(n, em);
          });
        })
        .catch(function () { err.textContent = strings.error || ''; })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---------- Quick Q&A (one open at a time) ---------- */
  function initFaq(root) {
    var list = root.querySelector('[data-faq]');
    if (!list || list._sp) return; list._sp = 1;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-faq-item]'));
    items.forEach(function (it) {
      var b = it.querySelector('button');
      b.addEventListener('click', function () {
        var was = it.classList.contains('is-open');
        items.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('button').setAttribute('aria-expanded', 'false'); });
        if (!was) { it.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-section-type="support-contact"]').forEach(function (r) { initContact(r); });
    (scope || document).querySelectorAll('[data-section-type="support-faq"]').forEach(initFaq);
  }
  if (window._spSupportInit) return; window._spSupportInit = 1;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
